// Test IDs for the legal interpreter landing page.
// All keys are camelCase, values are kebab-case shaped as `<feature>-<element>` or `<feature>-<element>-<qualifier>`.

export const INTERPRETER = {
  headerPhoneCta: 'interpreter-header-phone-cta',
  heroPhoneCta: 'interpreter-hero-phone-cta',
  heroWhatsappCta: 'interpreter-hero-whatsapp-cta',
  whatsappContactLink: 'interpreter-whatsapp-contact-link',
  mobileEmergencyFab: 'interpreter-mobile-emergency-fab',
  emailContactLink: 'interpreter-email-contact-link',
  phoneContactLink: 'interpreter-phone-contact-link',
  
  // Navigation elements
  navServices: 'interpreter-nav-services',
  navAvailability: 'interpreter-nav-availability',
  navLanguages: 'interpreter-nav-languages',
  navStatus: 'interpreter-nav-status',
  navZone: 'interpreter-nav-zone',
  navContact: 'interpreter-nav-contact',

  // Critical content indicators (for verification)
  professionalName: 'interpreter-professional-name',
  professionalTitle: 'interpreter-professional-title',
  emergencyBadge: 'interpreter-emergency-badge',
  expertStatus: 'interpreter-expert-status',
  zoneList: 'interpreter-zone-list',
  servicesList: 'interpreter-services-list',
  languagesList: 'interpreter-languages-list'
};
